import { defineStore } from 'pinia';
import type { LoginUser } from '@/api/user';
import sensors from '@/utils/shence';

interface UserState {
  uuid: string;
  nickname: string;
  avatar: string;
  mobile: string;
  id: string;
  uid: string;
  openid: string;
  token: string;
  startTime: string;
  endTime: string;
  sciRateStart: string;
  sciRateEnd: string;
  scType: string;
  institutionLevel: string;
  isInstitution: string;
}

const useUserStore = defineStore('KePuUser', {
  state: (): UserState => ({
    uuid: '',
    nickname: '',
    avatar: '',
    mobile: '',
    id: '',
    openid: '',
    uid: '',
    token: '',
    startTime: '',
    endTime: '',
    sciRateStart: '',
    sciRateEnd: '',
    scType: '', // 类型（0-全国、1-省、2-市、3-区县、4-乡镇街道）
    institutionLevel: '', //（1-全国、2-机构主、3-机构成员）
    isInstitution: '', //# 机构信息状态：0-待审核、1-审核通过、2-非机构、3-所属机构被禁用、4-所属机构被注销、5-机构被禁用、6-机构被注销
  }),
  actions: {
    /**
     * 重置登录用户信息
     *
     */
    resetLoginUser() {
      this.$reset();
    },
    /**
     * 存储登录用户信息
     *
     * @param {LoginUser} data
     */
    setLoginUser(data: LoginUser) {
      const {
        nickname = '',
        avatar = '',
        mobile = '',
        token = '',
        uid = '',
        id = '',
        uuid = '',
        openid = '',
      } = data;
      this.uuid = uuid;
      this.nickname = nickname;
      this.avatar = avatar;
      this.mobile = mobile;
      this.id = id;
      this.uid = uid;
      this.openid = openid;
      this.token = token;
      sensors.login(`login_user_${openid}`);
    },
    /**
     * 退出
     * @param param
     * @returns
     */
    logout() {
      this.resetLoginUser();
      sensors.logout();
    },
    /**
     * 地区数据选择月份（开始，结束）,以及占比时间（开始，结束）
     * @param param
     * @returns
     */
    changeTime(param: {
      start_time: string;
      end_time: string;
      sci_rate_start: string;
      sci_rate_end: string;
      sc_type: string;
      institution_level: string;
      is_institution: string;
    }) {
      const {
        start_time,
        end_time,
        sci_rate_start,
        sci_rate_end,
        sc_type,
        institution_level,
        is_institution,
      } = param;
      this.startTime = start_time;
      this.endTime = end_time;
      this.sciRateStart = sci_rate_start;
      this.sciRateEnd = sci_rate_end;
      this.scType = sc_type || '99';
      this.institutionLevel = institution_level;
      this.isInstitution = is_institution;
    },
  },
  persist: true,
});

export default useUserStore;
